/* Newsletter-subscription tooltip behaviour.
 *
 * Delegated on document so it also works for tooltips injected later (the cart
 * drawer register form is toggled in via Alpine — inline scripts there do not
 * run). Tap the icon to toggle; tap again, click outside, or press Escape to
 * close. Hover/focus is handled by CSS on pointer devices.
 */
(function () {
  'use strict';

  function closeAll(except) {
    var open = document.querySelectorAll('.subscribe-tooltip.is-open');
    for (var i = 0; i < open.length; i++) {
      if (open[i] === except) continue;
      open[i].classList.remove('is-open');
      var btn = open[i].querySelector('.subscribe-tooltip__icon');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    }
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;

    var icon = target.closest('.subscribe-tooltip__icon');
    if (icon) {
      // Toggle this tooltip; keep it from bubbling to the label/checkbox.
      e.preventDefault();
      e.stopPropagation();
      var tip = icon.closest('.subscribe-tooltip');
      if (!tip) return;
      var isOpen = tip.classList.toggle('is-open');
      icon.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      closeAll(tip);
      return;
    }

    // A click anywhere outside an open tooltip closes it.
    if (!target.closest('.subscribe-tooltip')) {
      closeAll(null);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') closeAll(null);
  });
})();
